import { useTourStore } from '@/store/useTourStore';
import i18n from '@/i18n';
import Shepherd from 'shepherd.js';
import { TFunction } from 'i18next';

const t: TFunction = i18n.t;

const ExpensesTour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    canClickTarget: false
  }
});

ExpensesTour.addStep({
  id: 'add-expense-step',
  text: () => t('tours.expenses.categories'),
  cancelIcon: {
    enabled: true
  },
  attachTo: {
    element: '.tour-category-grid',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: ExpensesTour.next
    }
  ]
});

ExpensesTour.addStep({
  id: 'more-expense-step',
  text: () => t('tours.expenses.moreCategories'),
  attachTo: {
    element: '.tour-category-grid-toggle',
    on: 'top'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: ExpensesTour.next
    }
  ]
});


ExpensesTour.addStep({
  id: 'expense-list-step',
  text: () => t('tours.expenses.list'),
  canClickTarget: true,
  attachTo: {
    element: '.tour-expense-list',
    on: 'top'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: ExpensesTour.next
    }
  ]
})

ExpensesTour.addStep({
  id: 'expense-all-step',
  text: () => t('tours.expenses.startFromJanuary'),
  attachTo: {
    element: '.tour-category-item',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.ok'),
      action: ExpensesTour.complete
    }
  ]
})


ExpensesTour.on('complete', () => {
  useTourStore.setState({ expensesTourCompleted: true });
});

ExpensesTour.on('cancel', () => {
  useTourStore.setState({ expensesTourCompleted: true });
});

export default ExpensesTour
